import type { NavLinkSubItem } from '../components/NavBar'

/** Products submenu, shared so every nav carrying it stays in step. */
export const PRODUCT_NAV_ITEMS: NavLinkSubItem[] = [
  {
    label: 'Commercial Insurance',
    href: '/insurance',
    description: 'Auto Liability, Cargo, Physical Damage, and more',
  },
  {
    label: 'Bookkeeper',
    href: '/bookkeeper',
    description: 'Books kept current and closed within 5 days, plus a live bookkeeper',
  },
  {
    label: 'FuelApp',
    href: '/fuelapp',
    description: 'Diesel discounts at top truck stop brands nationwide',
  },
  {
    label: 'AI CFO',
    href: '/cfo',
    description: 'Keeps a close eye on your money and helps you plan your next move',
    tag: 'Beta',
  },
  {
    label: 'Compliance',
    description: 'Proactive, automated compliance to keep your insurance premiums low',
    tag: 'Coming soon',
  },
]
